import { RouteName } from "@/lib/router/routes";

export default function (runId: string) {
  return {
    name: RouteName.run,
    params: {
      runId,
    },
  };
}
